import React from 'react';
import './banner.scss';

/**
 * Banner Component
 */
function Banner() {
   return (
      <div className="container-fluid home-banner">
         <div className="row justify-content-center banner-row">
            <div className="text">
               <p>...Showing the generation to come the praises of the Lord...</p>
               <p className="smaller-p">Ps 78.4b</p>
            </div>
         </div>
      </div>
   )
}

export default Banner;